import { Component, OnInit,  Input, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalRef, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';
import { Horse_show_entry } from '../../models/horse_show_entry';
import { Horse_show } from '../../models/horse_show';
import { Bill_item } from '../../models/accounting/bill_item';
import { Follow_up_payment_receipt } from '../../models/follow_up_payment_receipt';
import { EntryStatementService } from '../../providers/entry-statement.service';
import { HorseShowService } from '../../providers/horse-show.service';
import { PaymentCustomerService } from '../../providers/payment-customer.service';
import { PaymentService } from '../../providers/payment.service';
import { RefundPolicyService } from '../../providers/refund-policy.service';
import { ConvenienceFeeService } from '../../providers/convenience-fee.service';

import * as uuid from 'uuid';

import { Braintree_credit_card } from '../../models/accounting/banking/braintree_credit_card';

import { faCashRegister, faCreditCard, faDotCircle, faSpinner, faPlus, faUser, faSave } from '@fortawesome/pro-regular-svg-icons';
import {AccountEntryView} from '../../models/account_entry_view';
import {PendingHorseShowEntryService} from '../../providers/pending-horse-show-entry.service';

@Component({
  standalone: false,
  selector: 'app-modal-pay-balance',
  templateUrl: './modal-pay-balance.component.html',
styleUrls:  ['./modal-pay-balance.component.css']
})
export class ModalPayBalanceComponent extends SmsAbstractAppPage implements OnInit {
	horse_show_entry: Horse_show_entry;
	horse_show: Horse_show = new Horse_show({});
	additional_items: Bill_item[] = [];

	refund_policy_text: string = '';

	total_amount_to_pay: number = 0;

	payment_made$: EventEmitter<Follow_up_payment_receipt> = new EventEmitter<Follow_up_payment_receipt>();

	faCashRegister = faCashRegister;
	faCreditCard = faCreditCard;
	faDotCircle = faDotCircle;
	faSpinner = faSpinner;
	faPlus = faPlus;
	faUser =faUser;
	faSave = faSave;

	selected_credit_card: Braintree_credit_card = new Braintree_credit_card({});

	is_loading: boolean = false;
    is_submitted: boolean = false;

    order_uuid = uuid.v4();

  constructor(public activeModal: NgbActiveModal,
  	public modal: NgbModal,
  	private entryStatementService: EntryStatementService,
  	private horseShowService: HorseShowService,
  	private pendingHorseShowEntryService: PendingHorseShowEntryService,
  	private refundPolicyService: RefundPolicyService,
  	private convenienceFeeService: ConvenienceFeeService,
  	private paymentService: PaymentService) {
  	super();
  }

  ngOnInit() {
  }

	setHorse_show_entry(entryView: AccountEntryView){

    this.pendingHorseShowEntryService.get(entryView.entryId).then(horseShowEntry => {

      this.horse_show_entry = horseShowEntry;

      //Get statement
      this.entryStatementService.get(horseShowEntry.id).then(statement => {
        this.horse_show_entry.statement = statement;

        this.total_amount_to_pay = statement.balance;

        this.convenienceFeeService.get(horseShowEntry.id, statement.balance).then((convenience_fee: Bill_item | boolean) => {
          if(convenience_fee){
            this.additional_items.push(convenience_fee as Bill_item);
            this.total_amount_to_pay = this.total_amount_to_pay + (convenience_fee as Bill_item).amount;
          }
        }).catch(error => {
          this.handleError(error);
        });

        this.horseShowService.get(horseShowEntry.horse_show_id).then(horse_show => {
          this.horse_show = horse_show;
          this.refundPolicyService.getRefundPolicyHtml(horse_show.id, horse_show.competition_organizer_id).then(html => {
            this.refund_policy_text = html;
          }).catch(error => {
            this.handleError(error);
          });
        }).catch(error => {
          this.handleError(error);
        })
      }).catch(error => {
        this.handleError(error);
      });


    }).catch(error => {
      this.handleError(error);
    });

	  }

  handleSubmitPayment(){
  	this.is_submitted = true;

  	let entry_id_list: string[] = [];
  	entry_id_list.push(this.horse_show_entry.id);

if(this.horse_show.payment_gateway == 'BRAINTREE'){
    this.paymentService.submitPendingEntriesPayment(this.order_uuid,
    	this.selected_credit_card.token,
      	this.selected_credit_card.customer_id,
      	this.total_amount_to_pay,
      	this.horse_show_entry.horse_show_id,
      	entry_id_list,
	    this.additional_items).then(receipt => {
        this.payment_made$.emit(receipt);
      }).catch(error => {
      	this.is_submitted = false;
        this.handleError(error);
      });
    } else {
    	console.log("Not implemented yet for non Braintree payment Gateways.");
    }
  }

  handleSelectPaymentMethod(card: Braintree_credit_card | any){
    this.selected_credit_card = card;
  }


  handleCreditCardError(error: string){
    this.handleError(error);
  }

}
